import React from 'react';
import { observer } from 'mobx-react-lite';
import { Select } from '@insurancemenu/imenu-components-lib';
import { useRootStore } from 'store/rootStore';
import ActionModal from 'components/common/modals/ActionModal';
import { ModalType } from 'global/utils/ModalsHelper';
import { ShortCurrentPeriodInfo } from 'store/ui-stores/group-info/enrollmentCardStore';
import { createStyles } from './styles';

interface ChangeEffectiveDateModalProps {
  show: boolean;
  unavailableEffectiveDates: string[];
  currentPeriod: ShortCurrentPeriodInfo;
  updateEnrollments: () => Promise<void>;
  onClose: () => void;
}

const ChangeEffectiveDateModal: React.FC<ChangeEffectiveDateModalProps> = observer(
  ({ show, unavailableEffectiveDates, currentPeriod, updateEnrollments, onClose }) => {
    // Mobx store
    const rootStore = useRootStore();
    const classes = createStyles();

    const {
      changeEffectiveDateStore: { loading, effectiveDateForm, updateEffectiveDate, getAvailableEffectiveDateOptions },
    } = rootStore;

    const closeEffectiveDateModal = (): void => {
      onClose();
      effectiveDateForm.resetForm();
    };

    const changeEffectiveDate = async (): Promise<void> => {
      if (effectiveDateForm.fields.effectiveDate.value) {
        await updateEffectiveDate(currentPeriod.periodId, effectiveDateForm.fields.effectiveDate.value);
        await updateEnrollments();
      }
      closeEffectiveDateModal();
    };

    return (
      <ActionModal
        show={show}
        onClose={closeEffectiveDateModal}
        onAction={changeEffectiveDate}
        loading={loading}
        title="Change effective date"
        subtitle="Choose your desired effective date for this period from the dropdown below."
        actionButtonText="Save"
        modalType={ModalType.NOTIFICATION}
        modalContent={
          <form>
            <Select
              name="effectiveDate"
              options={getAvailableEffectiveDateOptions(unavailableEffectiveDates, currentPeriod.effectiveDate)}
              onChange={effectiveDateForm.onFieldChange}
              value={effectiveDateForm.fields.effectiveDate.value || currentPeriod.effectiveDate}
              width="30rem"
              className={classes.effectiveDateSelect}
            />
          </form>
        }
      />
    );
  },
);

export default ChangeEffectiveDateModal;
